const DOCUMENT = 'SESSIONS_FUTURE_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_GROUP_REQUEST: DOCUMENT + 'LOAD_GROUP_REQUEST',
  LOAD_GROUP_SUCCESS: DOCUMENT + 'LOAD_GROUP_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadSessionsFuture: data => {
    return {
      type: actions.LOAD_REQUEST,
      payload: data,
    };
  },

  loadSessionsFutureSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadGroupSessionsFuture: data => ({
    type: actions.LOAD_GROUP_REQUEST,
    payload: data,
  }),

  loadGroupSessionsFutureSuccess: data => ({
    type: actions.LOAD_GROUP_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
